<div class="topbar">
  <div class="section">

  </div>
  <div class="section right">
    <span class="small75s">
      <a *ngIf="!isLoggedIn()" routerLink="/login">zaloguj się</a>
      <span *ngIf="isLoggedIn()">{{ getUsername() }}</span>
      <a *ngIf="isLoggedIn()" routerLink="/logout"> [wyloguj się]</a>
    </span>
  </div>
</div>
